import buildColorTokensCss from './buildColorTokensCss.util';

export default function ColorTokensStyle() {
  return <style dangerouslySetInnerHTML={{ __html: buildColorTokensCss() }} />;
}
